// payrollProcessor.js
export default function createWorker() {
  return new Worker(
    URL.createObjectURL(
      new Blob(
        [
          `
      self.onmessage = function(e) {
        const payroll = e.data;
        let totalAmount = 0;
        const deductionMap = new Map();
  
        for (let i = 0; i < payroll.length; i++) {
          const employee = payroll[i];
          totalAmount += employee.netPay || 0;
          
          const deductions = employee.deductions || [];
          for (let j = 0; j < deductions.length; j++) {
            const d = deductions[j];
            const key = d.groupName || d.name;
            if (!key) continue;
            
            deductionMap.set(key, (deductionMap.get(key) || 0) + (d.total || 0));
          }
        }
  
        const deductions = [];
        deductionMap.forEach((amount, name) => {
          deductions.push({ name, amount });
        });
  
        self.postMessage({ totalAmount, deductions });
      };
    `,
        ],
        { type: "text/javascript" }
      )
    )
  );
}
// This code creates a web worker that processes payroll data and calculates total amounts and deductions.
// It listens for messages, processes the payroll data, and sends back the results.
